<div class="h-screen w-screen">
  <router-outlet></router-outlet>
</div>
